webpackJsonp([72],{

/***/ "4ON/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DifferentDevices = (function () {
    DifferentDevices.$inject = ["wistiaSvc"];
    function DifferentDevices(wistiaSvc) {
        var _this = this;
        this.wistiaSvc = wistiaSvc;
        this.wistiaInstances = [];
        var i = 0;
        _.each(this.videos, function (video) {
            _this.wistiaSvc.getWistiaPlayer(video.wistiaId).then(function (video) {
                _this.wistiaInstances.push(video);
                video.bind('play', function () {
                    video.time(0);
                    video.pause();
                    if (++i === 3) {
                        _this.playTogether();
                    }
                    return video.unbind;
                });
            });
        });
    }
    DifferentDevices.prototype.playTogether = function () {
        var _this = this;
        setTimeout(function () {
            _this.wistiaInstances.forEach(function (video) { return video.play(); });
        }, 0);
    };
    return DifferentDevices;
}());
angular.module('animatronApp.differentDevices', []).component('differentDevices', {
    bindings: {
        videos: '<'
    },
    controller: DifferentDevices,
    templateUrl: __webpack_require__("99ze")
});


/***/ }),

/***/ "99ze":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/different-devices_046be7f22484750b8d0d1652499f9c05.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/72-28dc41a6a889e793a2e2.min.js